export default __webpack_public_path__ + "0d49399d7169107a84860ec95f61a281.svg";